import axios from 'axios';

export const academicYearsService = {
  async getAll() {
    const res = await axios.get('/academic-years');
    return res.data.data || [];
  },
};
